import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { PagedCrudService } from "@features/grid";
import { IRavenPriority } from "./models/raven-priority";


@Injectable({
    providedIn: "root"
})
export class RavenPriorityService extends PagedCrudService<IRavenPriority> {
    public readonly url = "api/raven-api/priorities";
    public readonly entityTitle = "RavenPriority";


    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getAllPriorities(): Promise<IRavenPriority[]> {
        return this.handleRequest<IRavenPriority[]>(
            this.http.get<IRavenPriority[]>(`${this.url}/all-priorities`),
            this.handlersFactory.getForReadAll());
    }
}